<template>
    <div class="box">
        笔记首页
    </div>
</template>

<script>
export default {
    name:'note-index'
}
</script>

<style lang="scss" scoped>

</style>